import Head from 'next/head'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import { Box, Container } from '@mui/material'
import AboutUsContent from '../components/about/AboutUsContent'
import Founders from '../components/about/Founders'
import MetaAbout from '../components/meta/MetaAbout'

export default function About () {
  return (
    <>
      <MetaAbout />
      <Header />

      <Box
        component='main'
        sx={{ bgcolor: 'wrapper.main', pt: 10, color: 'wrapper.contrastText' }}
      >
        <Container maxWidth='xl'>
          <AboutUsContent />
        </Container>
      </Box>
      <Founders />
      <Footer />
    </>
  )
}
